import Base from "@/api/Base";

export default class Save extends Base
{
	setJobId (v)
	{
		this.jobId = v;
		return this;
	}

	setDomicile (v)
	{
		this.data.domicile = v;
		return this;
	}

	setMobilePhoneNumber (v)
	{
		this.data.mobilePhoneNumber = v;
		return this;
	}

	setPersonalData (v)
	{
		this.data.personalData = v;
		return this;
	}

	getMethod ()
	{
		return 'PUT';
	}

	getUrl ()
	{
		return '/job/' + this.jobId + '/questionnaire/legitimation';
	}
}
